// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../index.scss";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*SCSS mixins for devices*/
:root {
  --tile-bg: #ffffff;
  --tile-fg: #000000;
  --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  --background-blur: 7.76px;
}

[data-theme=light] {
  --tile-bg: #aaaaaa;
  --tile-fg: #000000;
  --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  --tile-bg-blur: rgba(0, 0, 0, 0.10);
}

[data-theme=dark] {
  --tile-bg: #666666;
  --tile-fg: #ffffff;
  --tile-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
  --tile-bg-blur: rgba(0, 0, 0, 0.29);
}

.debug {
  border: 1px solid red;
  background-color: aqua;
}

.Tile, .TileSet {
  background-color: var(--tile-bg);
  opacity: 1;
  border-radius: 20px;
  height: 100px;
  margin: 5px;
  width: 100px;
  transition: transform var(--transition-time) ease;
  z-index: 1;
  backdrop-filter: var(--background-blur);
  background: var(--tile-bg-blur);
}

.TileSet {
  position: relative;
  overflow: hidden;
  background: transparent;
  width: 100%;
  height: 100%;
  border-radius: 0 !important;
  /*Styles specific to the Nav postion bottom center | left | right*/
  /*Styles specific to the Nav postion bottom center | left | right*/
}
.TileSet.hide-buttons .react-multiple-carousel__arrow {
  display: none;
}
.TileSet.hide-buttons .react-multi-carousel-list {
  margin: 0;
}
.TileSet.bottom .react-multi-carousel-list {
  margin: 0 0 4rem 0;
}
.TileSet.bottom .react-multiple-carousel__arrow {
  top: 100%;
  margin-top: 1.5rem;
}
.TileSet.bottom.center .react-multiple-carousel__arrow--right {
  right: calc(47.5% + 1px);
}
.TileSet.bottom.center .react-multiple-carousel__arrow--left {
  left: calc(45% + 1px);
}
@media (min-width: 768px) and (max-width: 1024px) {
  .TileSet.bottom.center .react-multiple-carousel__arrow--right {
    right: calc(46% + 1px);
  }
  .TileSet.bottom.center .react-multiple-carousel__arrow--left {
    left: calc(43% + 1px);
  }
}
.TileSet.bottom.left .react-multiple-carousel__arrow--right {
  right: calc(88% + 1px);
}
.TileSet.bottom.left .react-multiple-carousel__arrow--left {
  left: calc(4% + 1px);
}
@media (min-width: 768px) and (max-width: 1024px) {
  .TileSet.bottom.left .react-multiple-carousel__arrow--right {
    right: calc(80% + 1px);
  }
  .TileSet.bottom.left .react-multiple-carousel__arrow--left {
    left: calc(4% + 1px);
  }
}
.TileSet.bottom.right .react-multiple-carousel__arrow--right {
  right: calc(3% + 1px);
}
.TileSet.bottom.right .react-multiple-carousel__arrow--left {
  left: calc(88% + 1px);
}
@media (min-width: 768px) and (max-width: 1024px) {
  .TileSet.bottom.right .react-multiple-carousel__arrow--right {
    right: calc(3% + 1px);
  }
  .TileSet.bottom.right .react-multiple-carousel__arrow--left {
    left: calc(80% + 1px);
  }
}
.TileSet.top .react-multi-carousel-list {
  margin: 4rem 0 0 0;
}
.TileSet.top .react-multiple-carousel__arrow {
  top: -60px;
}
.TileSet.top.center .react-multiple-carousel__arrow--right {
  right: calc(47.5% + 1px);
}
.TileSet.top.center .react-multiple-carousel__arrow--left {
  left: calc(45% + 1px);
}
@media (min-width: 768px) and (max-width: 1024px) {
  .TileSet.top.center .react-multiple-carousel__arrow--right {
    right: calc(46% + 1px);
  }
  .TileSet.top.center .react-multiple-carousel__arrow--left {
    left: calc(43% + 1px);
  }
}
.TileSet.top.left .react-multiple-carousel__arrow--right {
  right: calc(88% + 1px);
}
.TileSet.top.left .react-multiple-carousel__arrow--left {
  left: calc(4% + 1px);
}
@media (min-width: 768px) and (max-width: 1024px) {
  .TileSet.top.left .react-multiple-carousel__arrow--right {
    right: calc(80% + 1px);
  }
  .TileSet.top.left .react-multiple-carousel__arrow--left {
    left: calc(4% + 1px);
  }
}
.TileSet.top.right .react-multiple-carousel__arrow--right {
  right: calc(3% + 1px);
}
.TileSet.top.right .react-multiple-carousel__arrow--left {
  left: calc(88% + 1px);
}
@media (min-width: 768px) and (max-width: 1024px) {
  .TileSet.top.right .react-multiple-carousel__arrow--right {
    right: calc(3% + 1px);
  }
  .TileSet.top.right .react-multiple-carousel__arrow--left {
    left: calc(80% + 1px);
  }
}
.TileSet .tile-title {
  font-size: 2rem;
  display: block;
  font-style: normal;
  font-weight: 700;
  margin-bottom: 1.5rem;
}
.TileSet .multi-tile-slider {
  overflow: hidden;
}
.TileSet .multi-tile-slider div {
  display: flex;
  transition: transform 0.5s;
}
.TileSet .multi-tile-slider img {
  width: 82px;
  height: 82px;
  border-radius: 10px 10px;
}
.TileSet .react-multi-carousel-list {
  overflow: visible;
}
.TileSet .react-multiple-carousel__arrow {
  border-radius: 15%;
  min-width: 35px;
  min-height: 35px;
}
.TileSet .react-multiple-carousel__arrow::before {
  color: var(--color-bg);
}
@media (max-width: 767px) {
  .TileSet .react-multiple-carousel__arrow {
    display: none;
  }
}
.TileSet .react-multiple-carousel__arrow--left {
  background-color: var(--color-fg);
}
.TileSet .react-multiple-carousel__arrow--right {
  background-color: var(--color-fg);
}
.TileSet .react-multi-carousel-track .react-multi-carousel-item {
  padding: 0 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/_styles.scss","webpack://./src/components/Tile.scss","webpack://./src/components/TileSet.scss"],"names":[],"mappings":"AAAA,0BAAA;ACEA;EACI,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,yBAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,kBAAA;EACA,yCAAA;EACA,mCAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,kBAAA;EACA,+CAAA;EACA,mCAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,sBAAA;ACCJ;;ADEA;EACI,gCAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,iDAAA;EACA,UAAA;EACA,uCAAA;EACA,+BAAA;ACCJ;;AAkBA;EAEI,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EAYA,kEAAA;EAyBA,kEAAA;AAnDJ;AAiBQ;EACI,aAAA;AAfZ;AAkBQ;EACI,SAAA;AAhBZ;AAuBQ;EACI,kBAAA;AArBZ;AAwBQ;EACI,SAAA;EACA,kBAAA;AAtBZ;AAvBI;EACI,wBAAA;AAyBR;AAvBI;EACI,qBAAA;AAyBR;AFzDE;EEoCM;IACI,sBAAA;EAwBV;EAtBM;IACI,qBAAA;EAwBV;AACF;AAzEI;EACI,sBAAA;AA2ER;AAzEI;EACI,oBAAA;AA2ER;AFvEE;EEAM;IACI,sBAAA;EA0EV;EAxEM;IACI,oBAAA;EA0EV;AACF;AArEI;EACI,qBAAA;AAuER;AArEI;EACI,qBAAA;AAuER;AFrFE;EEkBM;IACI,qBAAA;EAsEV;EApEM;IACI,qBAAA;EAsEV;AACF;AADQ;EACI,kBAAA;AAGZ;AAAQ;EACI,UAAA;AAEZ;AAvEI;EACI,wBAAA;AAyER;AAvEI;EACI,qBAAA;AAyER;AFzGE;EEoCM;IACI,sBAAA;EAwEV;EAtEM;IACI,qBAAA;EAwEV;AACF;AAzHI;EACI,sBAAA;AA2HR;AAzHI;EACI,oBAAA;AA2HR;AFvHE;EEAM;IACI,sBAAA;EA0HV;EAxHM;IACI,oBAAA;EA0HV;AACF;AArHI;EACI,qBAAA;AAuHR;AArHI;EACI,qBAAA;AAuHR;AFrIE;EEkBM;IACI,qBAAA;EAsHV;EApHM;IACI,qBAAA;EAsHV;AACF;AA5BI;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;AA8BR;AA3BI;EACI,gBAAA;AA6BR;AA1BI;EACI,aAAA;EACA,0BAAA;AA4BR;AAzBI;EACI,WAAA;EACA,YAAA;EACA,wBAAA;AA2BR;AAxBI;EACI,iBAAA;AA0BR;AAvBI;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;AAyBR;AAvBQ;EACI,sBAAA;AAyBZ;AFlLE;EEmJE;IAUQ,aAAA;EAyBV;AACF;AAtBI;EACI,iCAAA;AAwBR;AArBI;EACI,iCAAA;AAuBR;AApBI;EACI,iBAAA;AAsBR","sourcesContent":["/*SCSS mixins for devices*/\n\n$mobile-max-width: 767px;\n\n@mixin mobile {\n  @media (max-width: $mobile-max-width) {\n    @content;\n  }\n}\n\n// Tablet screens (768px to 1024px)\n@mixin tablet {\n  @media (min-width: 768px) and (max-width: 1024px) {\n    @content;\n  }\n}\n\n// Desktop screens (1025px to 1439px)\n@mixin desktop {\n  @media (min-width: 1025px) and (max-width: 1439px) {\n    @content;\n  }\n}\n\n// Big monitor screens (1440px and up)\n@mixin big-monitor {\n  @media (min-width: 1440px) {\n    @content;\n  }\n}","@import url('../index.scss');\n\n:root { \n    --tile-bg: #ffffff;\n    --tile-fg: #000000;\n    --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n    --background-blur: 7.76px;\n}\n\n[data-theme=\"light\"] {\n    --tile-bg: #aaaaaa;\n    --tile-fg: #000000;\n    --tile-shadow: 0 0 5px rgba(0, 0, 0, 0.3);\n    --tile-bg-blur: rgba(0, 0, 0, 0.10);\n}  \n\n[data-theme=\"dark\"] {\n    --tile-bg: #666666;\n    --tile-fg: #ffffff;\n    --tile-shadow: 0 0 5px rgba(255, 255, 255, 0.3);\n    --tile-bg-blur: rgba(0, 0, 0, 0.29);\n}  \n\n.debug {\n    border: 1px solid red;\n    background-color: aqua;\n}\n\n.Tile {\n    background-color: var(--tile-bg);\n    opacity: 1;\n    border-radius: 20px;\n    height: 100px;\n    margin: 5px;\n    width: 100px;\n    transition: transform var(--transition-time) ease;\n    z-index: 1;\n    backdrop-filter: var(--background-blur);\n    background: var(--tile-bg-blur);\n}","@use '../styles';\n@use \"Tile.scss\";\n\n@mixin left-pos {\n    .react-multiple-carousel__arrow--right {\n        right: calc(88% + 1px);\n    }\n    .react-multiple-carousel__arrow--left {\n        left: calc(4% + 1px);\n    }\n\n    @include styles.tablet {\n        .react-multiple-carousel__arrow--right {\n            right: calc(80% + 1px);\n        }\n        .react-multiple-carousel__arrow--left {\n            left: calc(4% + 1px);\n        }\n    }\n}\n\n@mixin right-pos {\n    .react-multiple-carousel__arrow--right {\n        right: calc(3% + 1px);\n    }\n    .react-multiple-carousel__arrow--left {\n        left: calc(88% + 1px);\n    }\n\n    @include styles.tablet {\n        .react-multiple-carousel__arrow--right {\n            right: calc(3% + 1px);\n        }\n        .react-multiple-carousel__arrow--left {\n            left: calc(80% + 1px);\n        }\n    }\n}\n\n@mixin center-pos {\n    .react-multiple-carousel__arrow--right {\n        right: calc(47.5% + 1px);\n    }\n    .react-multiple-carousel__arrow--left {\n        left: calc(45% + 1px);\n    }\n\n    @include styles.tablet {\n        .react-multiple-carousel__arrow--right {\n            right: calc(46% + 1px);\n        }\n        .react-multiple-carousel__arrow--left {\n            left: calc(43% + 1px);\n        }\n    }\n}\n\n.TileSet {\n    @extend .Tile;\n    position: relative;\n    overflow: hidden;\n    background: transparent;\n    width: 100%;\n    height: 100%;\n    border-radius: 0!important;\n\n    &.hide-buttons {\n        .react-multiple-carousel__arrow {\n            display: none;\n        }\n\n        .react-multi-carousel-list {\n            margin: 0;\n        }\n    }\n\n    /*Styles specific to the Nav postion bottom center | left | right*/\n\n    &.bottom  {\n        .react-multi-carousel-list {\n            margin: 0 0 4rem 0;\n        }\n\n        .react-multiple-carousel__arrow { \n            top: 100%;\n            margin-top: 1.5rem;\n        }\n\n        &.center {\n            @include center-pos;\n        }\n\n        &.left {\n            @include left-pos;\n        }\n\n        &.right {\n            @include right-pos;\n        }\n    }\n\n    /*Styles specific to the Nav postion bottom center | left | right*/\n\n    &.top  {\n        .react-multi-carousel-list {\n            margin: 4rem 0 0 0;\n        }\n\n        .react-multiple-carousel__arrow { \n            top: -60px;\n        }\n\n        &.center {\n            @include center-pos;\n        }\n\n        &.left {\n            @include left-pos;\n        }\n\n        &.right {\n            @include right-pos;\n        }\n    }\n\n    .tile-title {\n        font-size: 2rem;\n        display: block;\n        font-style: normal;\n        font-weight: 700;\n        margin-bottom: 1.5rem;\n    }\n\n    .multi-tile-slider {\n        overflow: hidden;\n    }\n    \n    .multi-tile-slider div {\n        display: flex;\n        transition: transform 0.5s;\n    }\n    \n    .multi-tile-slider img {\n        width: 82px;\n        height: 82px;\n        border-radius:10px 10px;\n    }\n\n    .react-multi-carousel-list {\n        overflow: visible;\n    }\n\n    .react-multiple-carousel__arrow {\n        border-radius: 15%;\n        min-width: 35px;\n        min-height: 35px;\n\n        &::before {\n            color: var(--color-bg);\n        }\n\n        @include styles.mobile {\n            display: none;\n        }\n    }\n\n    .react-multiple-carousel__arrow--left {\n        background-color: var(--color-fg);\n    }\n\n    .react-multiple-carousel__arrow--right {\n        background-color: var(--color-fg);\n    }\n\n    .react-multi-carousel-track  .react-multi-carousel-item {\n        padding: 0 0.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
